import { render, staticRenderFns } from "./Whitecell.vue?vue&type=template&id=4f5ed9a1&scoped=true&"
import script from "./Whitecell.vue?vue&type=script&lang=js&"
export * from "./Whitecell.vue?vue&type=script&lang=js&"
import style0 from "./Whitecell.vue?vue&type=style&index=0&id=4f5ed9a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5ed9a1",
  null
  
)

export default component.exports